<template>
  <div v-if="messageStore.status.exceededUsageLimit" class="error-message">
    <InfoIcon class="icon-smaller icon-error icon-info" />
    <p class="small">{{ t('error_no_credit_message') }}</p>
    <a v-if="isVisibleUpgradeButton" class="link-small" @click="moveToUpgradePage">
      {{ t('label_upgrade') }}
    </a>
  </div>
  <div v-else-if="messageStore.status.remainingMinutes" class="error-message">
    <InfoIcon class="icon-smaller icon-error icon-info" />
    <p class="small">
      <i18n-t keypath="error_low_credit_message" scope="global">
        <template #minutes> {{ messageStore.status.remainingMinutes }} </template>
      </i18n-t>
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import InfoIcon from '@/components/icons/IconInfo.vue';
import { useMessageStore } from '@/stores/message';
import { TypeDomain } from '@/types/common';
import { ij_setBottomBarStatus } from '@/utils/injectionKeys';

const props = withDefaults(
  defineProps<{
    domain?: TypeDomain;
  }>(),
  {
    domain: 'ADMIN',
  }
);

const { t } = useI18n();
const router = useRouter();
const messageStore = useMessageStore();

const setBottomBarStatus = inject(ij_setBottomBarStatus, () => {});

// 업그레이드 버튼 노출 여부
const isVisibleUpgradeButton = computed<boolean>(() => {
  return props.domain === 'SELF_SERVICE';
});

const moveToUpgradePage = () => {
  router.push({ name: 'ss-plan-manage' });
};

watch(
  () => messageStore.status.exceededUsageLimit,
  (val) => {
    if (val) {
      setBottomBarStatus(2);
    }
  },
  { deep: true, immediate: true }
);
</script>

<style scoped lang="scss">
.alone-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  align-items: flex-start;
  max-width: 25rem;
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  gap: 0.25rem;
  margin: 0 1rem 0.75rem 1rem;
  background-color: var(--surface-primary-dimmest);
  outline: 1px solid var(--border-primary-dim);
  border-radius: 8px;
}

.chat-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  max-width: 25rem;
  padding: 0.25rem 0.75rem;
  gap: 0.25rem;
  margin: 0 1rem 0.75rem 1rem;
  text-align: center;
  background-color: var(--surface-gray-dimmest);
  outline: 1px solid var(--border-dim);
  border-radius: 16px;
}

.icon-info {
  position: relative;
  top: 0.125rem;
  flex-shrink: 0;
}

.error-message {
  position: relative;
  display: flex;
  width: fit-content;
  align-self: center;
  max-width: 25rem;
  padding: 0.25rem 0.75rem;
  gap: 0.25rem;
  margin: 0 1rem 0.75rem 1rem;
  text-align: center;
  background-color: var(--surface-error);
  border: 1px solid var(--border-error);
  border-radius: 16px;
}
</style>
